// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* reservationPopup */

.reservationPopup {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  max-width: 35rem;
  height: -moz-fit-content;
  height: fit-content;
  padding: 2.5em 2em;
  display: flex;
  flex-direction: column;
  margin: auto;
  align-items: center;
  box-shadow: 0px 0.5rem 2rem #00000015;
  border-radius: 0.5em;
  background: linear-gradient(to bottom, #f8f3ed, #fff);
  visibility: hidden;
  transform: scale(0);
  pointer-events: none;
  z-index: 100;
  transition: 0.25s;
}

.reservationPopup.show {
  transform: scale(1);
  opacity: 1;
  visibility: visible;
  pointer-events: all;
}

.reservationPopup img {
  width: 90%;
  border-radius: 1em;
  object-fit: cover;
  margin-bottom: 0.75rem;
  max-height: 13rem;
}

.reservationPopup h3 {
  font-size: 1.5rem;
  font-weight: bold;
}

.reservationPopup h4 {
  text-transform: uppercase;
  font-weight: 500;
  text-align: center;
  margin: 0.25rem 0 1.5rem 0;
  font-size: 0.9rem;
}

.reservationPopup__CloseIcon {
  max-width: 1.5rem;
  position: absolute;
  right: 1em;
  top: 1em;
  cursor: pointer;
  filter: invert(0.25);
}

.reservationPopup button {
  width: 100%;
  max-width: 12rem;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  background: var(--clr-primary);
  border-radius: 0.75em;
  color: var(--clr-light);
  padding: 0.75em 1.25em;
}

.reservationPopup button svg {
  max-width: 1.5rem;
  margin-right: 0.5rem;
  /* width: 1.25rem; */
  width: 1.5rem;
  fill: transparent;
}

.reservationPopup button svg rect,
.reservationPopup button svg path {
  stroke: var(--clr-light);
}
`, "",{"version":3,"sources":["webpack://./src/components/ReservationComponents/ReservationPopup/ReservationPopup.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,wBAAmB;EAAnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,oBAAoB;EACpB,qDAAqD;EACrD,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EAIpB,oBAAoB;EACpB,aAAa;EACb,iBAAiB;AALnB;;AAQA;;EAEE,wBAAwB;AAC1B","sourcesContent":["/* reservationPopup */\n\n.reservationPopup {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  max-width: 35rem;\n  height: fit-content;\n  padding: 2.5em 2em;\n  display: flex;\n  flex-direction: column;\n  margin: auto;\n  align-items: center;\n  box-shadow: 0px 0.5rem 2rem #00000015;\n  border-radius: 0.5em;\n  background: linear-gradient(to bottom, #f8f3ed, #fff);\n  visibility: hidden;\n  transform: scale(0);\n  pointer-events: none;\n  z-index: 100;\n  transition: 0.25s;\n}\n\n.reservationPopup.show {\n  transform: scale(1);\n  opacity: 1;\n  visibility: visible;\n  pointer-events: all;\n}\n\n.reservationPopup img {\n  width: 90%;\n  border-radius: 1em;\n  object-fit: cover;\n  margin-bottom: 0.75rem;\n  max-height: 13rem;\n}\n\n.reservationPopup h3 {\n  font-size: 1.5rem;\n  font-weight: bold;\n}\n\n.reservationPopup h4 {\n  text-transform: uppercase;\n  font-weight: 500;\n  text-align: center;\n  margin: 0.25rem 0 1.5rem 0;\n  font-size: 0.9rem;\n}\n\n.reservationPopup__CloseIcon {\n  max-width: 1.5rem;\n  position: absolute;\n  right: 1em;\n  top: 1em;\n  cursor: pointer;\n  filter: invert(0.25);\n}\n\n.reservationPopup button {\n  width: 100%;\n  max-width: 12rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  background: var(--clr-primary);\n  border-radius: 0.75em;\n  color: var(--clr-light);\n  padding: 0.75em 1.25em;\n}\n\n.reservationPopup button svg {\n  max-width: 1.5rem;\n  margin-right: 0.5rem;\n}\n\n.reservationPopup button svg {\n  /* width: 1.25rem; */\n  width: 1.5rem;\n  fill: transparent;\n}\n\n.reservationPopup button svg rect,\n.reservationPopup button svg path {\n  stroke: var(--clr-light);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
